import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Edit from '@material-ui/icons/Edit';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
  SvgIcon,
  TableContainer,
  Typography
} from '@material-ui/core';
import { ArrowRight } from 'react-feather';
import { useSelector } from 'react-redux';
import { useToggle } from 'src/hooks';

const SrchSubResults = ({ subList, handleSubSelect, showEdit, ixSubType }) => {
  const [
    isSubHaveTaxRegName,
    subHaveTaxRegName,
    subDontHaveTaxRegName
  ] = useToggle();
  const { tax } = useSelector(({ bizMeta }) => bizMeta);

  useEffect(() => {
    if (
      tax?.customers?.type_id === ixSubType ||
      (tax?.suppliers?.others || [])?.includes(ixSubType) ||
      tax?.suppliers?.type_id === ixSubType
    )
      subHaveTaxRegName();
    else subDontHaveTaxRegName();
  }, [tax]);

  if (subList == []) return null;

  return (
    <TableContainer>
      <Table>
        <TableBody>
          {subList.map(item => (
            <TableRow
              hover
              onClick={() => handleSubSelect(item)}
              key={item.sub_id}
            >
              <TableCell style={{ width: 80 }}>
                <Box display="flex" flexDirection="column">
                  <Typography variant="caption" display="block">
                    {item.sub_id}
                  </Typography>
                  <Typography
                    variant="caption"
                    display="block"
                    style={{
                      fontWeight: 900
                    }}
                  >
                    {item.RefNo}
                  </Typography>
                </Box>
              </TableCell>
              <TableCell>
                {isSubHaveTaxRegName
                  ? item[tax?.caption_source] ?? item.sub_title
                  : item.sub_title}
              </TableCell>
              <TableCell style={{ flex: 1 }} />
              <TableCell align="right">
                {showEdit && (
                  <IconButton
                    onClick={event => handleSubSelect(item, event, 'edit')}
                    tabIndex={-1}
                  >
                    <SvgIcon fontSize="small">
                      <Edit />
                    </SvgIcon>
                  </IconButton>
                )}
                <IconButton
                  onClick={() => handleSubSelect(item)}
                  className="controls"
                >
                  <SvgIcon fontSize="small">
                    <ArrowRight />
                  </SvgIcon>
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

SrchSubResults.propTypes = {
  className: PropTypes.string,
  subList: PropTypes.array.isRequired,
  handleSubSelect: PropTypes.func
};

export default SrchSubResults;
